import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";
import { useMemo, useState } from "react";
import DownloadAppPlusIconsWhite from "./download-app-plus-icons-white";
import GetICMAppModal from "@/app/components/get-icm-app-modal";
import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";
import { ProductRoute } from "@/types/product";
// import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";

interface Props {
    pageRoute: ProductRoute;
}

const InvestJourney: React.FC<Props> = ({ pageRoute }) => {
    const [showAppModal, setShowAppModal] = useState<boolean>(false);

    const toggleDownloadApp = () => {
        setShowAppModal(!showAppModal);
    };

    const eventNameFold2 = useMemo(() => {
        return `Home_Invest_Global_${pageRoute?.toUpperCase().replace("-", "_")}_Fold2`;
    }, [pageRoute]);

    return (
        <div className="flex flex-col items-center justify-center gap-s13 bg-[#202E79] bg-[url(https://assets.incredmoney.com/images/webp/ICMLogoPattern.webp)] bg-cover bg-y-pos-mobile bg-no-repeat py-s15 sm:py-s23 md:bg-y-pos-desktop">
            <div className="w-2/3 text-center text-3xl font-semibold leading-[31px] text-white md:w-3/5 md:text-7xl md:leading-[79.2px]">
                Invest in Leading US Companies with InCred Money
            </div>
            <div className="flex w-10/12 flex-col items-center justify-center gap-s7 sm:flex-row">
                <RegularButton
                    noIcon
                    showRightIcon={true}
                    rightIcon={<DownloadAppPlusIconsWhite />}
                    size={ButtonSize.Large}
                    variant={ButtonVariant.SecondaryDefault}
                    label="Download the app"
                    className="mb-2 h-[60px] w-full max-w-full bg-white sm:max-w-fit md:mb-0"
                    // onClick={() => (window.location.href = process.env.ICM_PLAYSTORE_URL || "")}
                    onClick={() => {
                        setAnalyticsEvent(
                            `${(window !== undefined && window.location.href) || ""}`,
                            `${eventNameFold2}`,
                        );
                        toggleDownloadApp();
                    }}
                />
            </div>

            <GetICMAppModal open={showAppModal} onClose={toggleDownloadApp} />
        </div>
    );
};

export default InvestJourney;
